export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-950">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[900px] mx-auto">
          <div className="text-center mb-12">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-50 font-bold mb-3">
              联系我们
            </h2>
            <p className="text-sm text-foreground-400 max-w-lg mx-auto">
              有任何问题、建议或合作意向，欢迎与我们取得联系
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            <div className="bg-background-800/50 border border-background-700/30 rounded-xl p-6 text-center group hover:border-primary-500/25 transition-all duration-300 cursor-pointer">
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-500/10 text-primary-400 group-hover:bg-primary-500/20 transition-colors">
                <i className="ri-mail-line text-xl"></i>
              </div>
              <h3 className="text-sm text-foreground-100 font-semibold mb-2">意见反馈</h3>
              <p className="text-xs text-foreground-400 leading-relaxed">
                对平台有任何意见或建议，请发送邮件至我们的客服邮箱
              </p>
              <span className="inline-block mt-3 text-xs text-primary-400">feedback@aikan.com</span>
            </div>

            <div className="bg-background-800/50 border border-background-700/30 rounded-xl p-6 text-center group hover:border-accent-500/25 transition-all duration-300 cursor-pointer">
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-accent-500/10 text-accent-400 group-hover:bg-accent-500/20 transition-colors">
                <i className="ri-shake-hands-line text-xl"></i>
              </div>
              <h3 className="text-sm text-foreground-100 font-semibold mb-2">商务合作</h3>
              <p className="text-xs text-foreground-400 leading-relaxed">
                广告投放、内容合作、品牌推广等商务合作事宜
              </p>
              <span className="inline-block mt-3 text-xs text-accent-400">biz@aikan.com</span>
            </div>

            <div className="bg-background-800/50 border border-background-700/30 rounded-xl p-6 text-center group hover:border-secondary-400/25 transition-all duration-300 cursor-pointer">
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-secondary-500/10 text-secondary-400 group-hover:bg-secondary-500/20 transition-colors">
                <i className="ri-movie-line text-xl"></i>
              </div>
              <h3 className="text-sm text-foreground-100 font-semibold mb-2">资源投稿</h3>
              <p className="text-xs text-foreground-400 leading-relaxed">
                如果您有优质影视资源希望收录，欢迎向我们投稿
              </p>
              <span className="inline-block mt-3 text-xs text-secondary-400">submit@aikan.com</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}